<script>
	import { nav } from './Navigation.svelte'
	export let href;
	export let cls = 'selected';
	$: selected = $nav._current 
		&& href.substr(href.indexOf('/')) === $nav._loc.substr($nav._loc.indexOf('/'));
</script>

<a {href} class={selected ? cls : ''}><slot/></a>

<style>
a {
		text-decoration:none;
		color: black;
		padding: 5px;
		margin: 5px;
	}

</style>